import React from 'react';
import _ from 'lodash';

import PropTypes from 'prop-types';
import useWindowSize from 'flaivy-react/hooks/UseWindowSize';

import { useRef, useEffect, useState } from 'react';
import { register } from 'swiper/element/bundle';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

register();

export const CarouselSlide = ({ children, className, style }) => {
  return (
    <swiper-slide
      class={className}
      style={{
        ...style,
      }}
    >
      {children}
    </swiper-slide>
  );
};

function Carousel({
  children,
  minHeight,
  spaceBetween,
  id,
  className,
  breakpointsBase,
  fullFlex = false,
}) {
  const swiperElRef = useRef(null);
  const carouselContainerRef = useRef(null);
  const [slidesPerView, setSlidesPerView] = useState(1);
  const childCount = children.length;

  const windowSize = useWindowSize();
  useEffect(() => {
    if (!swiperElRef.current) return;
    const carouselWidth = carouselContainerRef.current.clientWidth;

    const slideMinWidth = 225;

    const slideMaxWidth = 300;

    const newSlidesPerView = Math.max(
      1,
      Math.floor(carouselWidth / (slideMinWidth + 2 * spaceBetween)),
    );

    if (!fullFlex) {
      const maxSlidesPerView = Math.min(newSlidesPerView, childCount);

      swiperElRef.current.style.maxWidth = `${
        maxSlidesPerView * (slideMaxWidth + 2 * spaceBetween)
      }px`;
    }

    setSlidesPerView(newSlidesPerView);
  }, [windowSize]);

  const nextButtonId = `custom-next-button-${id}`;
  const prevButtonId = `custom-prev-button-${id}`;
  return (
    <>
      {children.length > 0 && (
        <div
          style={{
            minHeight: minHeight,
          }}
          ref={carouselContainerRef}
        >
          <div
            className="slider-main-container"
            style={childCount < slidesPerView ? { textAlign: 'left' } : {}}
          >
            <swiper-container
              ref={swiperElRef}
              slides-per-view={slidesPerView}
              space-between={spaceBetween}
              navigation="true"
              slides-per-group={1}
              pagination="false"
              navigation-next-el={`#${nextButtonId}`}
              navigation-prev-el={`#${prevButtonId}`}
              class={className}
              breakpointsBase={breakpointsBase}
              style={childCount < slidesPerView ? { marginLeft: 0 } : {}}
            >
              {children}
            </swiper-container>

            <div
              className={`swiper-nav-btn custom-prev-button `}
              id={prevButtonId}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                className="main-grid-item-icon"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              >
                <line x1="19" x2="5" y1="12" y2="12" />
                <polyline points="12 19 5 12 12 5" />
              </svg>
            </div>

            <div
              className={`swiper-nav-btn custom-next-button `}
              id={nextButtonId}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                className="main-grid-item-icon"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              >
                <line x1="5" x2="19" y1="12" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

Carousel.defaultProps = {
  children: [],
  spaceBetween: 10,
  onSlidesPerViewChange: () => {},
  minHeight: '420px',
  className: '',
  breakpointsBase: 'window',
};

Carousel.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  onSlidesPerViewChange: PropTypes.func,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  minHeight: PropTypes.string,
  breakpointsBase: PropTypes.string,
  spaceBetween: PropTypes.number,
};

export default Carousel;
